/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { Store } from 'redux';
import { IPropertiesValidator } from './ValidatorTypes';
import VisualizationTypeValidator from './VisualizationTypeValidator';
import ParameterNameValidator from './ParameterNameValidator';
import { IStateMetadataError } from '../store/types/StateTypes';
import ParameterValueValidator from './ParameterValueValidator';

class ValidatorFacade implements IPropertiesValidator {
    validators: IPropertiesValidator[];

    constructor(store: Store) {
        this.validators = [
            new VisualizationTypeValidator(store),
            new ParameterNameValidator(store),
            new ParameterValueValidator(store)
        ]
    }

    validate(properties:any) {
        return this.validators.reduce((memo, validator) => (memo || validator.validate(properties)), null as IStateMetadataError | null);
    }
}

export default ValidatorFacade;
